import { toComparableDate } from './rule-types.js';
const ISO_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})(?:T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:\d{2})?)?$/;
export function isCalendarDateString(value) {
    if (typeof value !== 'string')
        return false;
    const match = ISO_DATE_PATTERN.exec(value);
    if (match === null || toComparableDate(value) === undefined)
        return false;
    const [, year, month, day] = match;
    const probe = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
    return probe.getUTCMonth() === Number(month) - 1 && probe.getUTCDate() === Number(day);
}
//# sourceMappingURL=is-calendar-date-string.js.map